import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { CountryItem } from 'sections/Resources/FreightForwarder/data';
import { ListItem } from 'sections/Resources/FreightForwarder/components/Countries/components/ListItem';
import styles from 'sections/Resources/FreightForwarder/components/Countries/components/List/List.module.scss';

const cn = classNames.bind(styles);

type ListProps = {
  id: string;
  region: string;
  countries: CountryItem[];
}

const List: FC<ListProps> = ({ id, region, countries }: ListProps): ReactElement => {
  const countriesElements = countries.map((item: CountryItem) => {
    return (
      <ListItem key={item.id} name={item.name} url={item.url}/>
    );
  });

  return (
    <div className={cn('list')}>
        <h3 className={cn('list__heading')} id={id}>{region}</h3>
        <ul className={cn('list__items')}>
          {countriesElements}
        </ul>
    </div>
  );
};

export { List };